// extracted by mini-css-extract-plugin
export default {"container":"CIPTVPlanList_container__murdH","planList":"CIPTVPlanList_planList__HZqHf","planItem":"CIPTVPlanList_planItem__nsU2p","cButton":"CIPTVPlanList_cButton__AAloH"};